// import axios from 'axios';
import axios from '@/config/httpConfig'
export function getCode() {
    return axios.post('/admin/auth/getCode')
}

export function requestLogin(data) {
    return axios.post('/admin/auth/login', data)
}
// 获取用户数据API 
// URL ： http://dev.acspay.cn:8360/admin/user?page= 哪一页 &size= 每页显示的数据条数
// Method : Get 
export function getUserData(params) {
    console.log(params,"9999"); 
    return axios.get(`/admin/user`,params)
}
// 获取用户详细数据API
// http://dev.acspay.cn:8360/admin/user/info?id=用户ID （获取用户数据API 会返回）
// Method : Get 
export function getUserDataDetails(params) {
    return axios.get(`admin/user/info?id=${params}`)
}

// 获取订单数据API 
// URL ： http://dev.acspay.cn:8360/admin/order?page= 哪一页 &size= 每页显示的数据条数
// Method : Get 
// export function getOrder(params) {
//     console.log(params);
//     return axios.get(`admin/order?page=${params.page}&size=${params.size}`)
// }
export function getOrder(params) {
    console.log(params);
    return axios.get('admin/order', params)
}


//统计分析接口	
// PATH：/admin/index
// Method : Get
// Get参数{
// 	orderlimit：××××        //显示用户充值订单或者用户充值最前面的条数，例如 orderlimit = 3 则会显示充值最多的前3位用户和显示充值金额最多的3位用户
// } 
export function getIndex(params) {
    console.log(params);
    return axios.get('admin/index', params)
}

//规定时间内每天每月订单数
// export function getOrderTotal(params) {
//     return axios.get('/admin/index/orderTotal', params)
// }

//规定时间范围内订单成功失败退款数据
export async function getorderStatus(params) {
    return await axios.get('/admin/index/orderStatus', params)
}

//定时间范围内订单数量最多的用户排名	  
export function getorderMaxUser(params) {
    return axios.get('/admin/index/orderMaxUser', params)
}

//定时间范围内充值次数最多的读卡器排名	
export function getorderReaderStatus(params) {
    return axios.get('/admin/index/orderReaderStatus', params)
}

//规定时间内每天每月订单数
export function getorderTotal(params) {
    return axios.get('/admin/index/orderTotal', params)
}

//定时间范围充值成功金额最多的用户排名
export function getorderLoadAmountMaxUser(params) {
    return axios.get('/admin/index/orderLoadAmountMaxUser', params)
}

//当月金额和数量
export function getorderMaxAmountStatus(params) {
    return axios.get('admin/index/orderMaxAmountStatus', params)
}

/**###### 个人资料 ###### */
// //上传管理员图像  
// http://acspay.cn/admin/upload/setadminpic  
// Method : POST  
export function setadminpic(params) {
    return axios.post('/admin/upload/setadminpic', params)
}
// //用户密码修改  
// http://dev.acspay.cn:8360/admin/admin/updatapwd  
// Method : POST
// Post参数{ 
//     oPassword:  ××××,   //原密码
//     newPassword1: ××××, //新密码
//     newPassword2: ××××, //新密码
//      }   
export function updatapwd(params) {
    return axios.post('/admin/admin/updatapwd', params)
}

// //读卡器
// PATH:/admin/reader/list 
// Method : GET
// GET参数{ 
// 		id:                  //读卡器在数据库中的ID  不传此参数，获取所有读卡器
// // }

export function getReaderList(params) {
    return axios.get('/admin/reader/list', params)
}

//删除读卡器
// PATH:/admin/reader/delete 
// Method : POST
// Post参数{ 
// 		id:                  //读卡器在数据库中的ID
// }
export function postDelete(params) {
    return axios.post('/admin/reader/delete', params)
}

// /添加读卡器
// PATH:/admin/reader/store
// Method : POST 
export function postStore(params) {
    return axios.post('/admin/reader/store', params)
}
// 修改读卡器
export function IdPostStore(params) {
    return axios.post(`/admin/reader/store?id=${params}`, params)
}

//管理员列表		
// http://acspay.cn/admin/admin/list
// Method : GET
export function getAdminList(params) {
    return axios.get('/admin/admin/list', params)
}

//添加管理员
// http://dev.acspay.cn:8360/admin/admin/add
// Method : POST
// Post参数{ 
// 		  username:  ××××, 
// 		  password1: ××××, 
// 		  password2: ××××,
// 		  admin_role_id：0 或者 1,   //0 代表超级管理员 1 管理员 
// 	    } 

export function postAdaminAdd(params) {
    return axios.post('/admin/admin/add', params)
}

//删除管理员
// http://dev.acspay.cn:8360/admin/admin/delete
// Method : POST
// Post参数{ 
// 			adminID: ××××  //管理员ID, 
// 	    } 

export function postAdminDelete(params) {
    return axios.post('/admin/admin/delete', params)
}

//超级管理员修改管理员权限
// admin/admin/update
// Method : POST
// Post参数{ 
// 			id: ××××  //管理员ID, 
// 			admin_role_id：0 或者 1,   //0 代表超级管理员 1 管理员
// 	    } 
export function postAdminUpdate(params) {
    return axios.post('/admin/admin/update', params)
}



//Banner List		
// PATH：admin/banner/list
// Method : Get
export function bannerList(params) {
    return axios.get('/admin/banner/list', params)
}

//增加小程序banner	
// PATH：  admin/banner/add
// Method : POST
export function postBannerAdd(params) {
    return axios.post('/admin/banner/add', params)
}

//Banner 更新
// PATH：admin/banner/updatad		
// Method : POST
export function postBannerUpdatad(params) {
    return axios.post('/admin/banner/updatad', params)
}

//Banner 删除
// PATH： admin/banner/add		
// Method : POST
export function postBannerDelete(params) {
    return axios.post('/admin/banner/delete', params)
}
//upload image 分类
// PATH：/admin/imagecategory/store
// Method : POST
// add category 参数
// POST参数{
// 	pid: 此项分类的父ID 
//         name:分类名称	
// }
// edit category 参数
// POST参数{
// 	id : 分类ID
// 	pid: 此项分类的父ID 
//         name:分类名称	
// }
export function pictureClassification(params) {
    return axios.post('/admin/imagecategory/store', params)
}
//图像分类清单
// PATH：/admin/imagecategory/list
// Method : GET
// list
// GET参数{
// 	id：分类id   //如果没有此参数，则列出所有的分类数据
// }
export function getlistClass(params) {
    return axios.get('/admin/imagecategory/list', params)
}

//删除图像分类
// PATH：/admin/imagecategory/delete
// Method : POST
// delete category 参数
// POST参数{
// 	id：分类ID
// }
export function deletelistClass(params) {
    return axios.post('/admin/imagecategory/delete', params)
}

//图像清单
// PATH：/admin/upload/list
// Method : GET
// list
// GET参数{
// 	pid：图像分类pid   //根据分类ID 查询图像，   如果没有此参数，则列出所有的分类图像
// }
export function getListImages(params) {
    return axios.get('/admin/upload/list', params)
}

//上传iamge
// PATH: /admin/upload/uploadpic
// Method : POST
// Post参数{ 
// 		  pid:***            //图像分类ID
// 		  uploadFile：××××   //图像文件路径 ,图像大小需限制100K之内
// 	    } 		

// return：Data{
// 	"fileUrl": "https://acspay.cn/yg5uv8r29ed.png"  //图像文件的完整路径
// }
export function uploadImages(params) {
    return axios.post('/admin/upload/uploadpic', params)
}

//删除图像
// PATH：/admin/upload/delete
// Method : POST
// delete  参数
// POST参数{
// 	id：图像ID
// }
export function deleteImages(params) {
    return axios.post('/admin/upload/delete', params)
}

//更新iamge分类
// PATH: /admin/upload/uploadpic
// Method : POST
// Post参数{ 
// 		  id:***             //图像ID
// 		  pid:***            //图像分类ID
// 	    } 		
		
// return：Data{
// 	result：0 ro 1   //0更新失败 表示对应ID不存在，1 表示更新成功
// }
export function movingPictures(params) {
    return axios.post('/admin/upload/uploadpic', params)
}

//产品分类List
// PATH:/admin/category
// Method : GET
// GET参数{ 
// 	NULL
// }
export function productCategories(params) {
    return axios.get('/admin/category', params)
}

//////List产品
// PATH:/admin/goods
// Method : GET
// GET参数{ 
// 	name:  ××××××  //根据产品名称查询 如果无此参数表示List所有产品
// }
export function getGoodsActione(params) {
    return axios.get('/admin/goods', params)
}

//根据ID查询产品信息
// /admin/goods/info
// Method : GET
// GET参数{ 
// 	id:  ××××××  //根据产品id查询
// }
export function getGoodsId(params) {
    return axios.get('/admin/goods/info', params)
}

//添加产品
// PATH: /admin/goods/store
// Method : POST
// GET参数{ 
// 		category_id:*****    //产品分类id
// 		goods_sn：    		 //产品编号
// 		name：   			//产品名称
// 		goods_brief         //产品描述
// 		add_time：         //产品添加时间  时间戳格式
// 		sort_order：       //产品排序
// 		is_on_sale：      //产品是否显示
// 		primary_pic_url： //产品图像
// 		goods_url         //产品链接
// }
export function addProduct(params) {
    return axios.post('/admin/goods/store', params)
}

//删除产品分类
// PATH:/admin/goods/destory
// Method : POST
// GET参数{ 
// 		id:           //产品ID
// }
export function deleteProductCategories(params) {
    return axios.post('/admin/goods/destory', params)
}

//添加产品分类
// PATH: /admin/category/store
// Method : POST
// GET参数{ 
// 		name:*****    //分类名称
// 		keywords：    //分类关键词   方便用来查找
// 		parent_id：   //分类的上一级分类ID
// 		sort_order：  //分类排序
// 		image：       //分类图像
// 		add_time：    //分类建立时间  时间戳格式
// 		is_show：     //分类是否显示
// }
export function addCategoryList(params) {
    return axios.post('/admin/category/store', params)
}

//编辑产品分类
// PATH: /admin/category/add
// Method : POST
export function editCategoryList(params) {
    return axios.post('/admin/category/add', params)
}

// 删除产品分类
// PATH:/admin/category/destory
// Method : POST
// GET参数{ 
// 		id:           //分类ID
// }
export function destoryCategoryList(params) {
    return axios.post('/admin/category/destory', params)
}

// 权限规则
//显示所有菜单
// PATH:/admin/menu/list
// Method : GET
export function getMenuList(params) {
    return axios.get('/admin/menu/list', params)
}

//添加菜单
// PATH:admin/menu/store
// Method : POST
// POST参数{ 
// 		menu_name:*****      //菜单名称
// 		menu_path    		 //菜单请求URL API
// 		menu_parent_id   	//父菜单id,如果是子菜单，则记录其父菜单id,否则，0记录
// 		menu_method         //菜单请求方式  0 post 1 get
// 		component           //组件名称
// 		path                //组件路径
// 		iconCls             //菜单图标名称
// }
export function postMenuStore(params) {
    return axios.post('/admin/menu/store', params)
}

//编辑菜单
// Method : POST
// POST参数{ 
// 		menu_id             //菜单记录id
// 		menu_name:*****     //菜单名称
// 		menu_path    		//菜单请求URL API
// 		menu_parent_id   	//父菜单id,如果是子菜单，则记录其父菜单id,否则，0记录
// 		menu_method         //菜单请求方式  1 post 2 get
// 		component           //组件名称
// 		path                //组件路径
// 		iconCls             //菜单图标名称
// }
export function IdpostMenuStore(params) {
    return axios.post(`/admin/menu/store?id=${params}`, params)
}

//删除菜单
// PATH:admin/menu/delete
// Method : POST
// GET参数{ 
// 		menu_id:           //产品ID
// }
export function postMenuDelete(params) {
    return axios.post('/admin/menu/delete', params)
}

//添加角色
// PATH:admin/role/store
// Method : POST
// POST参数{ 
// 		name    		    //角色名称   例如：管理员，操作员
// 		available           //角色是否可用  0 不可用 1 可用
// }
export function postRoleStore(params) {
    return axios.post('/admin/role/store', params)
}

//编辑角色
// Method : POST
// POST参数{ 
// 		id                  //角色id
// 		name    		    //角色名称   例如：管理员，操作员
// 		available           //角色是否可用  0 不可用 1 可用
// }
export function IdpostRoleStore(params) {
    return axios.post(`/admin/role/store?id=${params}`, params)
}

//显示所有角色
// PATH:/admin/role/list
// Method : GET
// GET参数{ 
// 	Null
// }
export function getRoleList(params) {
    return axios.get('/admin/role/list', params)
}

//删除角色
// PATH:admin/role/delete
// Method : POST
// GET参数{ 
// 		id                  //角色id
// }
export function postRoleDelete(params) {
    return axios.post('/admin/role/delete', params)
}

//分配角色权限
//显示所有角色权限
// PATH:/admin/role_menu/list
// Method : GET
// GET参数{ 
// 	Null
// }
export function getRoleMenuList(params) {
    return axios.get('/admin/role_menu/list', params)
}

//添加角色权限
// PATH:admin/role_menu/store
// Method : POST
// POST参数{ 
// 		role_id    		    //角色ID  
// 		menu_id             //菜单ID
// }
export function postRoleMenuStore(params) {
    return axios.post('/admin/role_menu/store', params)
}

//编辑角色权限
// Method : POST
// POST参数{ 
// 		role_menu_id        //角色权限id
// 		role_id    		    //角色ID  
// 		menu_id             //菜单ID
// }
export function idPostRoleMenuStore(params) {
    return axios.post(`/admin/role_menu/store?id=${params}`, params)
}

//删除角色权限
// PATH:admin/role_menu/delete
// Method : POST
// GET参数{ 
// 		role_menu_id       //角色权限id
// }
export function postRoleMenuDelete(params) {
    return axios.post('/admin/role_menu/delete', params)
}



//用户名 用户ID 卡号 充值状态 
// PATH：/admin/order/orderSearch
// Method : GET
// POST参数{
// page = 哪一页       //如果不传此参数 默认第一个
// size = 每页显示的数据条数   //如果不传此参数 默认每页10条数据
// startdate : ***** //如果不传此参数   默认时间 1970-1-01  查询数据开始年月日 格式 2019-08-20
// enddate : *****   //如果不传此参数   默认为当前日期  查询数据结束年月日 格式 2019-08-20	

// pay_status=2&order_status=1       //退款成功记录
// pay_status=2&load_status=1        //充值成功记录
// pay_status=2&load_status=0        //充值失败记录 ，可以退款
// pay_status=0                      //支付失败记录

// pay_status=0			  //未支付
// pay_status=2			  //已经支付
// card_id                           //按卡号查询
// user_id				  //按用户ID查询
// user_name                         //按用户名查询
// device				  //按设备号查询 
export function getOrderSearch(params) {
    return axios.get('/admin/order/orderSearch', params)
}


// WEBPACK FOOTER //
// ./src/api/api.js